import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import "./styles/global.scss";
import Routes from "./routes";
import { Provider } from "react-redux";
import store from "./redux/Store";

const App: React.FC = () => (
    <Router>
      <Provider store={store}>
        <Routes />
      </Provider>
    </Router>
);

export default App;
